import { Cancel, SaveAlt } from '@mui/icons-material/'
import {  Fab, styled, TextField } from '@mui/material'
import { useFormik } from 'formik'
import { useEffect } from 'react'

import { useRefreshSignal } from '../../contexts/refreshSignal'
import { useBusinessLogic } from '../../hooks/useBusinessLogic'

const StyledForm = styled('form')(() => ({
  // paddingTop: '1rem',
  // paddingBottom: '1rem',
  display: 'flex',
  flexDirection: 'column'
  // marginBottom: '1rem'
}))

const StyledFab = styled(Fab)(() => ({
  // color: 'white',
  // text
}))

const ButtonContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between'
}))

const StyledTextField = styled(TextField)(() => ({
  marginBottom: '10px'
}))

export const UpdateForm = ({ itemToUpdate, setItemToUpdate }) => {

  const { updateItem: updateItemBusinessLogic } = useBusinessLogic()
  const { triggerRefresh } = useRefreshSignal()

  const formik = useFormik({
    enableReinitialize: true, // This allows formik to reinitialize when initialValues change
    initialValues: {
      _id: '',
      url: '',
      liked: false,
      comment: '',
      createdAt: null,
      updatedAt: null
    },
    onSubmit: async (values, { resetForm }) => {
      if (!values.comment) {
        return
      }

      try {
        await updateItemBusinessLogic({
          ...values,
          updatedAt: new Date()
        })
        // Signal Main.js to refresh the list

        // Clear the update form and reset AFTER everything is done
        resetForm()
        // setItemToUpdateCtx(null)
        triggerRefresh()
      } catch (error) {
        console.error('Error updating item:', error)
        // Keep the form open if there was an error
      }
    },
    onReset: async () => {
      setItemToUpdate(null)
      // setItemToUpdateCtx(null)
    }
  })

  // Update form values when context item changes
  useEffect(() => {
    if (itemToUpdate) {
      formik.setValues({
        _id: itemToUpdate._id || '',
        url: itemToUpdate.url || '',
        liked: itemToUpdate.liked || false,
        comment: itemToUpdate.comment || '',
        createdAt: itemToUpdate.createdAt || null,
        updatedAt: null
      })
    }
  }, [itemToUpdate?._id]) // Only depend on the item's ID, not the whole object or formik.setValues

  return (
    <>
      <StyledForm onSubmit={formik.handleSubmit}>
        <StyledTextField
          multiline
          rows={'4'}
          id="comment"
          label="update"
          variant="outlined"
          onChange={formik.handleChange}
          value={formik.values.comment}
        />
        <ButtonContainer>
          <StyledFab type="button" variant="extended" onClick={formik.handleReset} aria-label="cancel">
            <Cancel />
          </StyledFab>
          <StyledFab type="submit" variant="extended" value="updated it!" color="primary" aria-label="update">
            <SaveAlt />
          </StyledFab>
          
        </ButtonContainer>
      </StyledForm>
    </>
  )
}
